import { FC } from 'react';
import { CatIconMachineTractor } from '@blocks-react/components/Icons/MachineTractor';
import { CatUtilityNavItem } from '@blocks-react/components/UtilityNavItem';
import { CatPrimaryNavItem } from '@blocks-react/components/PrimaryNavItem';
import { MAIN_NAV_TRACK } from '../../../constants/analyticsConstants';
import cx from 'classnames';
import styles from './style.module.scss';

interface NavItemProps {
  'aria-controls'?: string;
  'aria-expanded'?: boolean;
  href: string;
  onClick?: () => void;
}

interface SubheaderMyEquipmentProps {
  displayMobileNavLink?: boolean;
  isCurrent?: boolean;
  id: string;
  label: string;
  navItemProps?: NavItemProps;
}
export const SubheaderMyEquipment: FC<SubheaderMyEquipmentProps> = ({
  displayMobileNavLink = false,
  id,
  isCurrent,
  navItemProps,
  label
}) => {
  const CatComponent = displayMobileNavLink
    ? CatPrimaryNavItem
    : CatUtilityNavItem;

  return (
    <CatComponent
      text={label}
      data-testId={
        displayMobileNavLink
          ? 'myEquipmentNavItemMobile'
          : 'myEquipmentNavItemDesktop'
      }
      id={id}
      isCurrent={isCurrent}
      {...navItemProps}
      data-track-event={MAIN_NAV_TRACK.EVENT}
      data-track-attr-nltext={MAIN_NAV_TRACK.MY_EQUIPMENT}
      data-track-attr-context={MAIN_NAV_TRACK.TOP_MENU_CONTEXT}
      className={cx({ [styles['item-border-bottom']]: displayMobileNavLink })}
      role="menu"
    >
      <CatIconMachineTractor slot="before" />
    </CatComponent>
  );
};
